// extracted by mini-css-extract-plugin
export var externalLink = "_dr-0";
export var internalLinkLabel = "_dr-1";